import { Wrapper } from 'shared/components/Wrapper';
import * as styles from './styles.css';
import { Block } from 'shared/components/Block';
import { BigTitle } from 'shared/components/BigTitle';
import { TextInfoWithImage } from 'shared/components/TextInfoWithImage';
import { LIST } from './constants';
import { Element } from 'react-scroll';
import { ENavigation } from 'shared/types/navigation';

export const UserExpirience: React.FC = () => {
  return (
    <div className={styles['container']}>
      <Wrapper>
        <Element name={ENavigation.AiInSearch}>
          <Block>
            <BigTitle text="Что стоит за пользовательским опытом" />
            <TextInfoWithImage
              title="Помощь с искусственным интеллектом в поиске и размещении объявлений"
              list={LIST}
              image="cube"
            />
          </Block>
        </Element>
      </Wrapper>
    </div>
  );
};
